import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { FsMapSearchServiceProvider, MapSearchServiceInterface } from '@lib/geo/core';
import { SnSearchbarOptionConfig } from '@lib/ui/searchbar';

@Injectable()
export class MapSearchFacadeService extends FsMapSearchServiceProvider {
  constructor(private readonly _searchService: MapSearchServiceInterface) {
    super();
  }

  public search(value: string): Observable<SnSearchbarOptionConfig[]> {
    return this._searchService.search(value);
  }
}
